import { render } from "./AgentChat.vue?vue&type=template&id=7d8e4917&scoped=true"
import script from "./AgentChat.vue?vue&type=script&lang=js"
export * from "./AgentChat.vue?vue&type=script&lang=js"

import "./AgentChat.vue?vue&type=style&index=0&id=7d8e4917&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8e4917"]])

export default __exports__